import { Component, Input, NgModule, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'svg-avatar',
  templateUrl: './svg-avatar.html',
  encapsulation: ViewEncapsulation.None
})
export class SvgAvatarComponent {
  @Input()
  id: number | string;
}

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SvgAvatarComponent
  ],
  exports: [
    SvgAvatarComponent
  ]
})
export class SvgAvatarModule {}
